import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A short lesson in debugging complex systems",
  "description": "",
  "published": "2019-07-26T00:00:00.000Z",
  "redirect_from": ["/blog/a-short-lesson-in-debugging-complex-systems/swizec/9166"],
  "categories": "Technical",
  "hero": "./img/techletter.app-screenshot-1564157906257.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hello friend 👋`}</p>
    <p>{`Today I wanted to share a quick lesson in debugging complex systems. It's from my upcoming course on building modern React apps with GraphQL, Serverless, and such. Currently a live video series :)`}</p>
    <p>{`On Tuesday we hit a snag that derailed the whole session. Unfortunate yes, but I think it produced a great teachable moment. How `}<em parentName="p">{`do`}</em>{` you debug complex systems and figure out what's wrong?`}</p>
    <p>{`enjoy ❤️`}</p>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/LKbOpZNYTuo"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M2%202L1%203%200%206l2%202%201-1h1c2%201%2010%202%2012%201h10c10%200%205-2-8-2C6%206%203%204%2014%204l7-1h-8L5%202%203%200%202%202M0%2090v71h10v13l-1%208-1%206-2%201c-2%200-2%200-1-1l-2-3c-5-1-4%204%201%205l3%201v6c-1%206-4%2014-4%2011l-1-2c-2%200-2%202-2%2010v9h401v-10c0-6-1-8-1-5v6h-3l-3%201-1%201-2-1c0-1-1-1-1%201h-2c0-2-1-2-8-2s-8%200-8%202c0%201-2%203-4%203-1%200%200-2%202-2v-1h-3c-3%202-3%202-3%200s-1-2-4-2c-2%200-3%200-2%201v5c-2%201-5-3-3-4%201-2-43-3-118-2h-14v-11l-1-97V21l-16-1h-17v14l3-1c3%200%203%200%203%203%200%202%200%202-1%200%200-3-2-3-6%202-4%203-4%203-2%204%201%201%201%201-2%201h-3l2-2%202-3-50-1H20V19H0v71m11-38v6l1%205h12V51l-6-1c-4%200-6%201-7%202m15%201v10h12V52l-6-1c-6%200-6%200-6%202m30-2c-2%201-3%205-1%2010%200%202%201%202%206%202h6v-6c0-5%200-6-2-6h-9m-16%206l1%206h11v-4c2-8%202-8-6-8h-6v6m29%200v6h12V51H69v6m14%200l1%206h12V52l-7-1h-6v6m22%206c-3%203-1%209%203%2012l1%203v5l2%204-3-1-6-2c-3%200-3%200-2%202%202%201%202%201%201%202v2h2c0-2%201-2%204%201%207%206%209%204%2013-11%201-4%203-6%204-6l1-1c-1-1-7%200-9%202-3%201-7-2-6-5%201-2%201-2-1-2-1%200-2%200-1-1l-1-4c-1-2-1-2-2%200m2%2043c-3%201-4%202-5%204l-3%203-1%202c0%201-1%202-3%202l-8%203-4%201%203%202%206%201c2%200%203%200%203%202-1%201-1%201%208%201l8%201%202-1c1-1%200-2-1-4-2-3-2-3-1-5%202-1%203-6%201-6l-4%206c-3%207-5%207-5%201%200-4%202-7%204-7l1-1%202-2%201%201%201%201v-6l-5%201m-41%2055c-18%200-20%200-18%201%203%202%205%202%2014%204%206%201%207%202%209%204%202%203%200%205-5%205l-4%201h-1c-3-2-9%203-7%205l3-2c4-3%205-2%202%202l-3%204-1%201-2%201%2013-1h4c2%202%203%201%203-1-1-3-1-3%2022-8%2016-3%2021-5%2019-8l-1-4v-4H66m1%2028v5l-1-2c-2-3-2-3-8-3-5%200-5%201-5%203%200%204-5%205-6%202h-1v2c1%202%200%203-3%201-1-2-3-2-3-1%200%203%206%206%209%204l3%202%204%203%202%201c1%202%209%206%2012%206%202%200%202-1%201-3l1-3c2%201%202%200%200-2-1-1-1-1%201-1l2-1-2-2c-2-1-2-3%201-2l2-1c1-1-2-7-3-7-1%201-2%200-2-1-1-3-3-2-4%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d7ef239d7d4d7eb8c9d2aae309777705/ca0a1/techletter.app-screenshot-1564157906257.webp 223w", "/static/d7ef239d7d4d7eb8c9d2aae309777705/75680/techletter.app-screenshot-1564157906257.webp 445w", "/static/d7ef239d7d4d7eb8c9d2aae309777705/0ba47/techletter.app-screenshot-1564157906257.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d7ef239d7d4d7eb8c9d2aae309777705/e92b6/techletter.app-screenshot-1564157906257.png 223w", "/static/d7ef239d7d4d7eb8c9d2aae309777705/e66bf/techletter.app-screenshot-1564157906257.png 445w", "/static/d7ef239d7d4d7eb8c9d2aae309777705/6af66/techletter.app-screenshot-1564157906257.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d7ef239d7d4d7eb8c9d2aae309777705/6af66/techletter.app-screenshot-1564157906257.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Near the beginning a wild error appeared: 403 Forbidden.`}</p>
    <p>{`GraphQL failed. Nothing went through.`}</p>
    <p>{`It was a great lesson in systematically debugging complex systems. And in the end we did get our `}<inlineCode parentName="p">{`allWidget(userId: "some-long-id")`}</inlineCode>{` to work.`}</p>
    <p>{`As Nico later said`}</p>
    <blockquote>
      <p parentName="blockquote">{`Even though we didn't make a lot of measurable progress this evening, I still feel like I learned a lot about the troubleshooting side of things 🙂 Notably, creating the basic apollo server was 👌. You explained how to narrow down where the issue could be via simplification, and that thought process might not exist for audience members that don't have an Ops or DevOps background.`}</p>
    </blockquote>
    <p>{`Thanks Nico ❤️`}</p>
    <p>{`Here's how it all went down 👇`}</p>
    <h2 {...{
      "id": "add-userid-to-the-allwidget-query"
    }}>{`Add userId to the allWidget query`}</h2>
    <p>{`We wanted to display per user widget lists on the homepage.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cd622762e24154b8dfd41b951f932e1e/636d3/UilWIZl.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "43.946188340807176%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'176\\'%20viewBox=\\'0%200%20400%20176\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M37%2045v15l1%2014h160l162-1c1-1%202-24%200-27%200-3-322-3-323-1m47%2033v5c0%206-2%207-2%201l-1-3v3c0%205-2%205-2%201s-1-5-4-4c-2%200-1%202%201%201%202%200%202%200%200%201-2%202-3%202-3%200-1-2-2-2-6-2s-4%200-4%204c0%202%200%203-2%203v-1c1-1%201-1-1-1h-3l3-1c3%200%203-3-1-4-1%200-2%200-1%201l2%201h-2c-2-1-3%201-2%203v2c-1%201%205%201%2014%201h16l-1-4-1-7m-14%2029l-2%202c-2-1-4%203-2%205v2c-2%200-2-1-2-4s0-4-1-3l-1%204c0%202%200%203-2%203v-2l1-4c0-2%200-2-1%200l-2%203v-2l-2-3v4c2%204%202%204%200%204-1%201%206%201%2015%201s16%200%2015-1c-2%200-2%200-1-2%202-2%201-5-2-5s-4%203-2%206c1%201%201%201-1%201-3%200-3%200-2-2%201-1%201-1-1-1h-2c-1-1%200-1%201-1%203%200%204-1%202-3-3-2-5%200-5%204v3l-1-5-1-5-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cd622762e24154b8dfd41b951f932e1e/ca0a1/UilWIZl.webp 223w", "/static/cd622762e24154b8dfd41b951f932e1e/75680/UilWIZl.webp 445w", "/static/cd622762e24154b8dfd41b951f932e1e/8d1ba/UilWIZl.webp 890w", "/static/cd622762e24154b8dfd41b951f932e1e/41bb6/UilWIZl.webp 1222w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cd622762e24154b8dfd41b951f932e1e/e92b6/UilWIZl.png 223w", "/static/cd622762e24154b8dfd41b951f932e1e/e66bf/UilWIZl.png 445w", "/static/cd622762e24154b8dfd41b951f932e1e/4ef49/UilWIZl.png 890w", "/static/cd622762e24154b8dfd41b951f932e1e/636d3/UilWIZl.png 1222w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/cd622762e24154b8dfd41b951f932e1e/4ef49/UilWIZl.png",
              "alt": "UilWIZl",
              "title": "UilWIZl",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`That shows `}<inlineCode parentName="p">{`email`}</inlineCode>{` and `}<inlineCode parentName="p">{`video`}</inlineCode>{` widgets which is a fine list, but check this out: They're from two different users.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0fdf82bccfd37419a6f1bd9e6241b278/a4f52/sT9HUBd.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "21.973094170403588%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'88\\'%20viewBox=\\'0%200%20400%2088\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M4%208v8h396V0H91v7H49V0H4v8m295%2017c0%202%200%203%205%203l6-1%201-1%201%201%202%201%201-1h1l14%201c7%200%208-1%208-2-1-2-7-2-8%200l-2-1-2-2v3h-1c0-2-6-2-7%200h-1l-5-1-5-1h-4l-1%201c-2%201-2%201-2-1-1-1-1-1-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0fdf82bccfd37419a6f1bd9e6241b278/ca0a1/sT9HUBd.webp 223w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/75680/sT9HUBd.webp 445w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/8d1ba/sT9HUBd.webp 890w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/3838e/sT9HUBd.webp 1335w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/e11e5/sT9HUBd.webp 1780w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/f2636/sT9HUBd.webp 2024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0fdf82bccfd37419a6f1bd9e6241b278/e92b6/sT9HUBd.png 223w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/e66bf/sT9HUBd.png 445w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/4ef49/sT9HUBd.png 890w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/4e814/sT9HUBd.png 1335w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/701e9/sT9HUBd.png 1780w", "/static/0fdf82bccfd37419a6f1bd9e6241b278/a4f52/sT9HUBd.png 2024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/0fdf82bccfd37419a6f1bd9e6241b278/4ef49/sT9HUBd.png",
              "alt": "sT9HUBd",
              "title": "sT9HUBd",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Best way to fix that is changing our `}<inlineCode parentName="p">{`allWidget`}</inlineCode>{` query so it accepts a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and returns a list of widgets just for that user. It's important this filtering happens on the backend so data the user shouldn't see never reaches their browser.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20backend%2Fsrc%2Fgraphql.ts%0A%0Atype%20Query%20%7B%0A%20%20%20%20widget(widgetId%3A%20String!)%3A%20Widget%0A%20%20%20%20allWidget(userId%3A%20String)%3A%20%5BWidget%5D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "414px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'268\\'%20viewBox=\\'0%200%20400%20268\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2048l-1%2087%201%2085%202%202%20166%201%20166-1%203-2v-85l-1-87c-2-2-334-2-336%200m35%2015c-4%204-2%209%204%209%203%200%205-2%205-5%200-5-6-8-9-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5f2bf2dcc6713a6ba5556f3f139e0e3b/ca0a1/techletter.app-screenshot-1564157796906.webp 223w", "/static/5f2bf2dcc6713a6ba5556f3f139e0e3b/3ca80/techletter.app-screenshot-1564157796906.webp 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/5f2bf2dcc6713a6ba5556f3f139e0e3b/e92b6/techletter.app-screenshot-1564157796906.png 223w", "/static/5f2bf2dcc6713a6ba5556f3f139e0e3b/b910a/techletter.app-screenshot-1564157796906.png 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/5f2bf2dcc6713a6ba5556f3f139e0e3b/b910a/techletter.app-screenshot-1564157796906.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The query now accepts a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` parameter.`}</p>
    <p>{`Passing a few extra arguments into the `}<inlineCode parentName="p">{`scanItems`}</inlineCode>{` query in our resolver makes the magic work.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20backend%2Fsrc%2Fqueries.ts%0A%0Aexport%20const%20allWidget%20%3D%20async%20(_%3A%20any%2C%20%7B%20userId%20%7D%3A%20%7B%20userId%3A%20string%20%7D)%20%3D%3E%20%7B%0A%20%20%20%20const%20result%20%3D%20await%20scanItems(%7B%0A%20%20%20%20%20%20%20%20FilterExpression%3A%20%22%23user%20%3D%20%3AuserId%22%2C%0A%20%20%20%20%20%20%20%20ExpressionAttributeNames%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%22%23user%22%3A%20%22userId%22%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20ExpressionAttributeValues%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%22%3AuserId%22%3A%20userId%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "710px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2028c-2%202-2%20160%200%20162s360%202%20362%200%202-160%200-162-360-2-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f3b1547d2b1487a761685d8d4126f82a/ca0a1/techletter.app-screenshot-1564157796857.webp 223w", "/static/f3b1547d2b1487a761685d8d4126f82a/75680/techletter.app-screenshot-1564157796857.webp 445w", "/static/f3b1547d2b1487a761685d8d4126f82a/457aa/techletter.app-screenshot-1564157796857.webp 710w"],
                "sizes": "(max-width: 710px) 100vw, 710px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f3b1547d2b1487a761685d8d4126f82a/e92b6/techletter.app-screenshot-1564157796857.png 223w", "/static/f3b1547d2b1487a761685d8d4126f82a/e66bf/techletter.app-screenshot-1564157796857.png 445w", "/static/f3b1547d2b1487a761685d8d4126f82a/7131f/techletter.app-screenshot-1564157796857.png 710w"],
                "sizes": "(max-width: 710px) 100vw, 710px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f3b1547d2b1487a761685d8d4126f82a/7131f/techletter.app-screenshot-1564157796857.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`DynamoDB scan queries can be cumbersome. Getting a list of everything is easy – no arguments – a specific list takes 3 arguments. That's a lot 🤨`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`FilterExpression`}</inlineCode>{` says what we're filtering by. Equality with `}<inlineCode parentName="li">{`userId`}</inlineCode>{` in our case`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ExpressionAttributeNames`}</inlineCode>{` maps filter attributes to table columns`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ExpressionAttributeValues`}</inlineCode>{` maps filter value placeholders to real values`}</li>
    </ul>
    <h2 {...{
      "id": "try-the-query-and-403"
    }}>{`Try the query and 403`}</h2>
    <p>{`We decided to test our new query in Apollo Playground first. This would let us focus on the query itself and not on the details of Gatsby or React being just right.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ebc2789fcd129bb3ba4670d8a407034e/7ad71/8pADxrw.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "32.28699551569507%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'130\\'%20viewBox=\\'0%200%20400%20130\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2073v57h401V16H0v57m199-9c-3%201-6%206-6%2010%200%2011%2014%2015%2020%206s-4-20-14-16\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ebc2789fcd129bb3ba4670d8a407034e/ca0a1/8pADxrw.webp 223w", "/static/ebc2789fcd129bb3ba4670d8a407034e/75680/8pADxrw.webp 445w", "/static/ebc2789fcd129bb3ba4670d8a407034e/8d1ba/8pADxrw.webp 890w", "/static/ebc2789fcd129bb3ba4670d8a407034e/3838e/8pADxrw.webp 1335w", "/static/ebc2789fcd129bb3ba4670d8a407034e/e11e5/8pADxrw.webp 1780w", "/static/ebc2789fcd129bb3ba4670d8a407034e/7bb17/8pADxrw.webp 2338w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ebc2789fcd129bb3ba4670d8a407034e/e92b6/8pADxrw.png 223w", "/static/ebc2789fcd129bb3ba4670d8a407034e/e66bf/8pADxrw.png 445w", "/static/ebc2789fcd129bb3ba4670d8a407034e/4ef49/8pADxrw.png 890w", "/static/ebc2789fcd129bb3ba4670d8a407034e/4e814/8pADxrw.png 1335w", "/static/ebc2789fcd129bb3ba4670d8a407034e/701e9/8pADxrw.png 1780w", "/static/ebc2789fcd129bb3ba4670d8a407034e/7ad71/8pADxrw.png 2338w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/ebc2789fcd129bb3ba4670d8a407034e/4ef49/8pADxrw.png",
              "alt": "8pADxrw",
              "title": "8pADxrw",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And that's when all hell broke loose.`}</p>
    <p>{`Server unreachable. Console full of `}<inlineCode parentName="p">{`Forbidden: 403`}</inlineCode>{` errors. Gatsby local server crashed out on us. Everything died.`}</p>
    <p><img parentName="p" {...{
        "src": "/e6294f6ac6f3e71c7a086c84e491cb56/media-xT1XGWbE0XiBDX2T8Q-giphy.gif",
        "alt": "oh_the_calamity giphy"
      }}></img></p>
    <h2 {...{
      "id": "narrow-down-the-problem"
    }}>{`Narrow down the problem`}</h2>
    <p>{`Something was clearly very wrong. But we didn't change anything that could cause this did we? 🤔`}</p>
    <p><strong parentName="p">{`Zeroth step`}</strong>{` check the logs, but there were no useful errors there. This is a sign you're about to go on a wild ride.`}</p>
    <p><strong parentName="p">{`First step`}</strong>{` make sure we didn't change something.`}</p>
    <p>{`Git checkout the old version of our server. Deploy the lambdas. Try our playground again. If this works, we know some code change on our end broke the server.`}</p>
    <p>{`Still didn't work.`}</p>
    <p>{`Okay `}<strong parentName="p">{`second step`}</strong>{` try to remember what was wrong last time something like this happened.`}</p>
    <p>{`We had a problem a few sessions ago where our lambda wasn't configured to accept POST requests. Looking at `}<inlineCode parentName="p">{`serverless.yml`}</inlineCode>{` confirmed that POST requests are in fact configured.`}</p>
    <p><strong parentName="p">{`Third step`}</strong>{` is Serverless messing up somehow and misconfiguring AWS APIGateway?`}</p>
    <p>{`Looked into the AWS dashboard. Spelunked through the UI and found a configuration for our APIGateway. Everything looked right. GET requests connected to our lambda. So are POST requests.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f8a3739d34433ca5be875bb3d576aacb/6149e/lRkbepv.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.63677130044843%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'187\\'%20viewBox=\\'0%200%20400%20187\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M69%2020c-2%202%201%205%203%205h2l1%201h1c1%201%202%201%205-1%201-2%202-2%202-1%201%202%208%202%209%200h1c0%201%203%202%205%201%202%200%203-3%201-4H77l-1%201-1%202-1-2c-2-3-3-3-5-2m121%2043l-4%201h-11c-12%200-11%200-11%201l12%201%2012-1h4l4%201%205-1h1c1%201%206%203%206%201h2c2%201%205%200%205-1%200-2-10-2-11-1h-1c0-2-5-2-13-1m-60%2032c-4%203-1%203%2039%203%2035%200%2041-1%2041-2s-6-2-40-2l-40%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f8a3739d34433ca5be875bb3d576aacb/ca0a1/lRkbepv.webp 223w", "/static/f8a3739d34433ca5be875bb3d576aacb/75680/lRkbepv.webp 445w", "/static/f8a3739d34433ca5be875bb3d576aacb/8d1ba/lRkbepv.webp 890w", "/static/f8a3739d34433ca5be875bb3d576aacb/3838e/lRkbepv.webp 1335w", "/static/f8a3739d34433ca5be875bb3d576aacb/e11e5/lRkbepv.webp 1780w", "/static/f8a3739d34433ca5be875bb3d576aacb/0160b/lRkbepv.webp 2784w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f8a3739d34433ca5be875bb3d576aacb/e92b6/lRkbepv.png 223w", "/static/f8a3739d34433ca5be875bb3d576aacb/e66bf/lRkbepv.png 445w", "/static/f8a3739d34433ca5be875bb3d576aacb/4ef49/lRkbepv.png 890w", "/static/f8a3739d34433ca5be875bb3d576aacb/4e814/lRkbepv.png 1335w", "/static/f8a3739d34433ca5be875bb3d576aacb/701e9/lRkbepv.png 1780w", "/static/f8a3739d34433ca5be875bb3d576aacb/6149e/lRkbepv.png 2784w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f8a3739d34433ca5be875bb3d576aacb/4ef49/lRkbepv.png",
              "alt": "lRkbepv",
              "title": "lRkbepv",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Okay what else can we try?`}</p>
    <p><strong parentName="p">{`Fourth step`}</strong>{` try deploying to a new stage. Maybe we clicked something in the UI that broke things in a way Serverless can't correct.`}</p>
    <p>{`So we ran `}<inlineCode parentName="p">{`sls deploy -s dev2`}</inlineCode>{` to create a whole new AWS setup for our service. Everything fresh and from scratch. Make sure the environment isn't the problem.`}</p>
    <p>{`Nope. Still broken.`}</p>
    <p>{`🤔`}</p>
    <p>{`Okay `}<strong parentName="p">{`fifth step`}</strong>{` reduce our server to the absolute smallest possible setup. Make sure `}<em parentName="p">{`nothing`}</em>{` about our code could be causing this.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20backend%2Fsrc%2Fgraphql.ts%0A%2F%2F%20PS%3A%20this%20is%20pseudocode%2C%20refer%20to%20the%20video%20for%20actual%20code%0A%0Aconst%20types%20%3D%20gql%60%0A%09Query%20%7B%0A%09%09hello%3A%20%7B%20hello%3A%20String%20%7D%0A%09%7D%0A%60%0A%0Aexport%20const%20server%20%3D%20new%20ApolloServer(%7B%0A%20%20%20%20types%2C%0A%20%20%20%7B%0A%09%20%20%20Query%3A%20%7B%0A%09%09%20%20%20hello%3A%20()%20%3D%3E%20%7B%20hello%3A%20%22hello%22%20%7D%0A%09%20%20%20%7D%0A%20%20%20%7D%0A%7D)%3B%0A%0Aexport%20const%20handler%20%3D%20server.createHandler(%7B%0A%20%20%20%20cors%3A%20%7B%0A%20%20%20%20%20%20%20%20origin%3A%20%22*%22%2C%0A%20%20%20%20%20%20%20%20credentials%3A%20true%0A%20%20%20%20%7D%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "590px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "101.79372197309418%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'407\\'%20viewBox=\\'0%200%20400%20407\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2033l-1%20171v170l3%201h350l3-1V204l-1-171c-2-2-352-2-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/654e6f80a80b103def759c86e2a422c4/ca0a1/techletter.app-screenshot-1564157796979.webp 223w", "/static/654e6f80a80b103def759c86e2a422c4/75680/techletter.app-screenshot-1564157796979.webp 445w", "/static/654e6f80a80b103def759c86e2a422c4/5ca24/techletter.app-screenshot-1564157796979.webp 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/654e6f80a80b103def759c86e2a422c4/e92b6/techletter.app-screenshot-1564157796979.png 223w", "/static/654e6f80a80b103def759c86e2a422c4/e66bf/techletter.app-screenshot-1564157796979.png 445w", "/static/654e6f80a80b103def759c86e2a422c4/fcda8/techletter.app-screenshot-1564157796979.png 590w"],
                "sizes": "(max-width: 590px) 100vw, 590px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/654e6f80a80b103def759c86e2a422c4/fcda8/techletter.app-screenshot-1564157796979.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`If that works, we know the problem is somewhere in how we configured GraphQL.`}</p>
    <p><strong parentName="p">{`Sixth step`}</strong>{` getting desperate, but what if we create a server that just returns a hello world?`}</p>
    <p>{`That was a dead end too. Now what ...`}</p>
    <p><strong parentName="p">{`Seventh step`}</strong>{` start googling. Has anyone else had this problem before?`}</p>
    <p>{`We found an old github issue on Apollo's repository. Something about Apollo playground using the wrong server URL ...`}</p>
    <h2 {...{
      "id": "the-facepalm-🤦♀️"
    }}>{`The facepalm 🤦‍♀️`}</h2>
    <p>{`That was it. Apollo was using the wrong server URL.`}</p>
    <p><img parentName="p" {...{
        "src": "/5796b79bf0f9aa2951a48178e4c97ea0/qUtTfYK.gif",
        "alt": null
      }}></img></p>
    <p>{`Change the target URL to `}<inlineCode parentName="p">{`/dev/graphql`}</inlineCode>{` and everything works. Everything.`}</p>
    <p>{`It wasn't a change that we made breaking things at all. And to make matters worse: Gatsby crashed because of a completely unrelated problem but it confirmed our fears that the server is broken 🤦‍♀️`}</p>
    <p><img parentName="p" {...{
        "src": "/4b4f6e0263635bfc47508a4d626987a7/media-ADr35Z4TvATIc-giphy.gif",
        "alt": "facepalm giphy"
      }}></img></p>
    <h2 {...{
      "id": "make-allwidget-work-without-userid"
    }}>{`Make allWidget work without userId`}</h2>
    <p>{`Gatsby crashed not because our server was broken but because it queries `}<inlineCode parentName="p">{`allWidget`}</inlineCode>{` to create pages for thumbsup/thumbsdown.`}</p>
    <p>{`We have to make the query work with `}<em parentName="p">{`and`}</em>{` without `}<inlineCode parentName="p">{`userId`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20backend%2Fsrc%2Fqueries.ts%0A%0Aexport%20const%20allWidget%20%3D%20async%20(_%3A%20any%2C%20%7B%20userId%20%7D%3A%20%7B%20userId%3F%3A%20string%20%7D)%20%3D%3E%20%7B%0A%20%20%20%20%2F%2F%20Query%20by%20userId%20if%20passed-in%2C%20otherwise%20return%20all%20widgets%0A%20%20%20%20const%20result%20%3D%20await%20scanItems(%0A%20%20%20%20%20%20%20%20userId%0A%20%20%20%20%20%20%20%20%20%20%20%20%3F%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20FilterExpression%3A%20%22%23user%20%3D%20%3AuserId%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ExpressionAttributeNames%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%23user%22%3A%20%22userId%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ExpressionAttributeValues%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%3AuserId%22%3A%20userId%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3A%20%7B%7D%0A%20%20%20%20)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "718px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.3677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'265\\'%20viewBox=\\'0%200%20400%20265\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2028a4224%204224%200%20001%20210h361l1-106V28l-182-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/620640c7c76d413b6c0ec993fbb0bd67/ca0a1/techletter.app-screenshot-1564157797079.webp 223w", "/static/620640c7c76d413b6c0ec993fbb0bd67/75680/techletter.app-screenshot-1564157797079.webp 445w", "/static/620640c7c76d413b6c0ec993fbb0bd67/7d0c9/techletter.app-screenshot-1564157797079.webp 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/620640c7c76d413b6c0ec993fbb0bd67/e92b6/techletter.app-screenshot-1564157797079.png 223w", "/static/620640c7c76d413b6c0ec993fbb0bd67/e66bf/techletter.app-screenshot-1564157797079.png 445w", "/static/620640c7c76d413b6c0ec993fbb0bd67/57dc1/techletter.app-screenshot-1564157797079.png 718w"],
                "sizes": "(max-width: 718px) 100vw, 718px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/620640c7c76d413b6c0ec993fbb0bd67/57dc1/techletter.app-screenshot-1564157797079.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Make the `}<inlineCode parentName="p">{`userId`}</inlineCode>{` optional, pass arguments into `}<inlineCode parentName="p">{`scanItems`}</inlineCode>{` based on whether it's available.`}</p>
    <p>{`And just like that everything works again. That was fun.`}</p>
    <h2 {...{
      "id": "to-recap"
    }}>{`To recap`}</h2>
    <p>{`We used what I've heard referred to as the Sherlock method 👉 make a hypothesis, find clues, follow every clue to its end. Repeat until solved.`}</p>
    <p>{`You can tackle any debugging problem this way.`}</p>
    <p>{`Cheers, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      